module.exports = __webpack_public_path__ + "static/img/btn4.5ad6dd78.png";